import React, { useEffect, useState } from "react";
import "../components/layout/blog/BlogPage.css";
import Header from "../components/layout/header/Header";
import Footer from "../components/layout/footer/Footer";
import { Sparkles } from "lucide-react";
import { useParams } from "react-router-dom";
import { getBlogByIdOrSlug, getBlogs } from "../api/blog/blogApi";
import { useNavigate } from "react-router-dom";

const BlogPage: React.FC = () => {
  const { idOrSlug } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState<any>(null);
  const [relatedBlogs, setRelatedBlogs] = useState<any[]>([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!idOrSlug) return;

    const loadBlog = async () => {
      try {
        setLoading(true);

        const response = await getBlogByIdOrSlug(idOrSlug);

        console.log("Full Response:", response);
        console.log("Blog Data:", response.data);

        const blogData = response.data;

        setBlog({
          ...blogData,
          image: blogData.coverImage,
          description: blogData.excerpt,
          publishedDate: new Date(blogData.publishedAt).toLocaleDateString(),
          readTime: `${blogData.readTime} min read`,
        });

        const related = await getBlogs({
          limit: 3,
        });

        const uniqueRelated = Array.from(
          new Map(
            related.data
              .filter((item: any) => item.slug !== blogData.slug)
              .map((item: any) => [item.slug ?? item.id, item]),
          ).values(),
        );

        setRelatedBlogs(uniqueRelated);
      } catch (err) {
        console.error(err);
        setBlog(null);
      } finally {
        setLoading(false);
      }
    };

    loadBlog();
  }, [idOrSlug]);

  if (loading) {
    return (
      <div className="page-shell--blog">
        <Header />
        <div className="blog-loading">Loading...</div>
        <Footer />
      </div>
    );
  }

  if (!blog) {
    return (
      <>
        <Header />
        <div className="blog-loading">Blog not found.</div>
        <Footer />
      </>
    );
  }

  return (
    <div className="page-shell--blog">
      <Header />
      <main className="blog-page">
        {/* ================= HERO ================= */}

        <section className="blog-hero">
          <span className="editorial-badge">
            <Sparkles size={16} />
            Editorial Analysis
          </span>

          <h1 className="blog-title">{blog.title}</h1>

          <p className="blog-subtitle">{blog.description}</p>

          <div className="blog-meta">
            <div className="author">
              <img src={blog.author?.avatar} alt={blog.author?.name} />

              <span>By {blog.author?.name}</span>
            </div>

            <span className="meta-divider"></span>

            <div className="meta-item">
              <span>{blog.readTime}</span>
            </div>

            <span className="meta-divider"></span>

            <div className="meta-item">
              <span>{blog.publishedDate}</span>
            </div>
          </div>
          <div className="hero-divider"></div>
        </section>

        {/* ================= CONTENT ================= */}

        <section className="blog-wrapper">
          {/* LEFT */}

          <article className="blog-content">
            <div
              className="blog-content-html"
              dangerouslySetInnerHTML={{
                __html: blog.content,
              }}
            />
          </article>

          <aside className="blog-sidebar">
            {blog.tags?.length > 0 && (
    <div className="related-card">
      <h4>Tags</h4>

      <div className="blog-tags">
        {blog.tags.map((tag: string) => (
          <span key={tag} className="blog-tag">
            {tag}
          </span>
        ))}
      </div>
    </div>
  )}

  <div className="related-card">
    <h4>Related Insights</h4>

    {relatedBlogs.map((item) => (
      <div
        key={item.id}
        className="related-item"
        onClick={() => navigate(`/blogs/${item.slug}`)}
        style={{ cursor: "pointer" }}
      >
        <small>{item.category?.title}</small>
        <h5>{item.title}</h5>
        <span>{item.readTime} min read</span>
      </div>
    ))}
  </div>


            <div className="subscribe-card">
              <small>Stay Ahead</small>

              <h3>Join the Future</h3>

              <p>
                Get the latest AI strategy, product insights, and technical deep
                dives delivered straight to your inbox.
              </p>

              <div className="subscribe-input">
                <input type="email" placeholder="Email Address" />
              </div>

              <button>Subscribe</button>

              <span>No spam. Only intelligence.</span>
            </div>
          </aside>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;
